module.exports = __webpack_public_path__ + "img/1501406035.1967abba.jpg";